module.exports = __webpack_public_path__ + "static/media/kiron.7a03d507.jpeg";